<template>
  <div>
    <section>
      <div :class="isLoading ? 'pt-6' : ''">
        <Skeleton :loading="isLoading" lineHeight="2"/>
      </div>
      <div>
        <div
          v-for="method in paymentMethods" :key="method.id"
          class="py-3 h-16 flex justify-between items-center border-b">
          <input type="radio" :value="method.id" v-model="selectedPaymentMethod"
          role="checkbox" v-if="radioButtons">
          <iban :iban="method" @deleted="getPaymentMethods()" />
        </div>
      </div>
      <div class="w-full mt-6 flex justify-between items-center"
      v-if="!notShowAddButton && !isLoading">
        <button class="p-2 px-6 rounded-md hover:bg-beige-academy-300
        hover:text-white shadow-md text-xs md:text-md"
          @click="addNewPaymentMethod()">
            {{ $t('iban.add') }}
        </button>
      </div>
    </section>
    <div class="mt-6" v-if="addNewIban">
      <button class="hover:text-b2c-red-300 flex justify-end w-full"
        @click="addNewIban=false" title="delete" >
          <close-icon />
      </button>
      <sepa :intent="intent" @updated-payment-method="rechargePaymentMethods()" />
    </div>
  </div>
</template>

<script>
import CloseIcon from '@/components/graphics/CloseIcon.vue';
import { mapGetters } from 'vuex';
import { Skeleton } from '@/components/Skeleton/src/index';
import { getStudentPaymentMethods } from '@/services/StudentService';
import { getStudentSetupIntent } from '@/services/PaymentService';
import Iban from './Iban.vue';
import Sepa from './Sepa.vue';

export default {
  props: ['radioButtons', 'notShowAddButton', 'value', 'add'],

  data() {
    return {
      startAdding: !!this.add,
      addNewIban: false,
      intent: null,
      paymentMethods: [],

      selectedPaymentMethod: this.value,

      idToDelete: '',

      isLoading: false,
    };
  },

  components: {
    CloseIcon,
    Iban,
    Sepa,
    Skeleton,
  },

  watch: {
    deletedPaymentMethod() {
      this.getPaymentMethods();
    },

    selectedPaymentMethod() {
      this.$emit('input', this.selectedPaymentMethod);
    },
  },

  computed: {
    ...mapGetters({
      student: ['auth/student'],
      deletedPaymentMethod: ['auth/deletedPaymentMethod'],
    }),
  },

  mounted() {
    if (this.student) {
      this.getPaymentMethods();
    }
  },

  methods: {
    getPaymentMethods() {
      this.isLoading = true;
      this.paymentMethods = [];
      getStudentPaymentMethods(this.student.id, 'Sepas').then((response) => {
        this.paymentMethods = response.data;
        this.isLoading = false;
        this.selectedPaymentMethod = this.paymentMethods.length > 0
          ? this.paymentMethods[0].id : null;
        if (this.addNewIban) {
          this.addNewIban = false;
        }
        if (this.startAdding) {
          this.addNewPaymentMethod();
          this.startAdding = false;
        }
      }).catch(() => {
        this.isLoading = false;
        this.createNotification('error', `${this.$t('notifications.errorReload')}`);
      });
    },

    addNewPaymentMethod() {
      this.addNewIban = true;
      getStudentSetupIntent(this.student.id).then((response) => {
        this.intent = response.data.intent;
      });
    },

    rechargePaymentMethods() {
      this.getPaymentMethods();
    },

    setLoadingClass(id) {
      if (this.isLoading && this.idToDelete === id) return 'loader';
      return '';
    },

  },
};
</script>
